module.exports = __webpack_public_path__ + "media/Antarctic_Circle.fe5eba22.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/labels/Antarctic_Circle.png
// module id = 1117
// module chunks = 0